export default __webpack_public_path__ + "static/media/gameHistory.6617079f.svg";